<template>
    <transition name="modal-fade">
      <div class="modal-overlay" v-show="visible" @click.self="handleClose">
        <div class="modal-container">
          <div class="modal-header" v-show="isHeader">
            <slot name="header">
              <h3>{{ title }}</h3>
              <button class="modal-close" @click="handleClose">&times;</button>
            </slot>
          </div>
          <div class="modal-body">
            <slot></slot>
          </div>
          <div class="modal-footer" v-if="$slots.footer">
            <slot name="footer"></slot>
          </div>
        </div>
      </div>
    </transition>
  </template>
  
  <script>
  export default {
    props: {
      visible: {
        type: Boolean,
        default: false
      },
      isHeader:{
        type: Boolean,
        default: false
      },
      title: {
        type: String,
        default: '提示'
      },
      closeOnClickOverlay: {
        type: Boolean,
        default: true
      }
    },
    methods: {
      handleClose() {
        if (this.closeOnClickOverlay) {
          this.$emit('update:visible', false);
          this.$emit('close');
        }
      }
    },
  };
  </script>
  
  <style scoped>
  /* 遮罩层样式 */
  .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 999;
  }
  
  /* 弹窗容器样式 */
  .modal-container {
    animation: modal-scale 0.3s ease-out;
    transform-origin: center center;
  }
  
  /* 弹窗动画 */
  @keyframes modal-scale {
    from {
      transform: scale(0.8);
      opacity: 0;
    }
    to {
      transform: scale(1);
      opacity: 1;
    }
  }
  
  /* 弹窗各部分样式 */
  .modal-header {
    padding: 15px 20px;
    border-bottom: 1px solid #eee;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  
  .modal-body {
    padding: 20px;
  }
  
  .modal-footer {
    padding: 15px 20px;
    border-top: 1px solid #eee;
    text-align: right;
  }
  
  .modal-close {
    background: transparent;
    border: none;
    font-size: 20px;
    cursor: pointer;
    color: #999;
  }
  
  .modal-close:hover {
    color: #333;
  }
  
  /* 过渡动画 */
  .modal-fade-enter-active,
  .modal-fade-leave-active {
    transition: opacity 0.3s;
  }
  
  .modal-fade-enter,
  .modal-fade-leave-to {
    opacity: 0;
  }
  
  .modal-fade-enter-active .modal-container,
  .modal-fade-leave-active .modal-container {
    transition: all 0.3s;
  }
  
  .modal-fade-enter .modal-container,
  .modal-fade-leave-to .modal-container {
    transform: scale(0.8);
    opacity: 0;
  }
  </style>